import { AddDataSources } from '../_partials/AddDataSources';

export default function AddDataSource() {
  return (
    <main data-testid="add-datasource-page">
      <AddDataSources />
    </main>
  );
}
